import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BillingDashboard from '../components/BillingDashboard';
import PageHeader from '../components/PageHeader';
import { CreditCard, PartyPopper } from 'lucide-react';

export default function Billing() {
  const { user, company, token, isSuperUser, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center" style={{ background: '#0B1321', color: '#A0AEC0' }}>Loading...</div>;
  }

  const canViewBilling = isSuperUser || user?.role === 'admin';
  if (!canViewBilling) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6" style={{ background: '#0B1321' }} data-testid="billing-forbidden">
        <div className="max-w-md text-center">
          <CreditCard className="w-12 h-12 mx-auto mb-4" style={{ color: '#64748B' }} />
          <h2 className="text-xl font-bold text-white mb-2">Billing is restricted</h2>
          <p className="text-sm mb-5" style={{ color: '#A0AEC0' }}>
            Only the account owner and administrators can view billing and subscription details for this company.
          </p>
          <button
            onClick={() => navigate('/dashboard')}
            className="px-4 py-2 rounded-lg text-white font-medium"
            style={{ background: '#1E88E5' }}
            data-testid="billing-back-to-dashboard"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" style={{ background: '#0B1321' }} data-testid="billing-page">
      <PageHeader title="Billing" subtitle="Subscription, seats, and invoices" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {new URLSearchParams(window.location.search).get('reactivated') === '1' && (
          <div
            className="mb-5 p-4 rounded-xl flex items-start gap-3"
            style={{ background: 'rgba(0,200,150,0.1)', border: '1px solid rgba(0,200,150,0.4)' }}
            data-testid="billing-reactivated-banner"
          >
            <PartyPopper className="w-5 h-5 mt-0.5" style={{ color: '#00C896' }} />
            <div>
              <p className="text-sm font-semibold text-white">Welcome back — you're reactivated! 🎉</p>
              <p className="text-xs" style={{ color: '#A0AEC0' }}>
                Your subscription is active and your whole team has full access again. Nothing was lost while you were away.
              </p>
            </div>
          </div>
        )}
        <BillingDashboard company={company} token={token} canManage={isSuperUser} />
      </div>
    </div>
  );
}
